import { render, staticRenderFns } from "./W0096V0001.vue?vue&type=template&id=bc01bd0c&scoped=true&"
import script from "./W0096V0001.vue?vue&type=script&lang=js&"
export * from "./W0096V0001.vue?vue&type=script&lang=js&"
import style0 from "./W0096V0001.vue?vue&type=style&index=0&id=bc01bd0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc01bd0c",
  null
  
)

export default component.exports